import React, { Fragment, useEffect } from "react";
import Home from "../home.svg";
import styled from "@emotion/styled";
import { Button, Text, Heading, Box, Image } from "@chakra-ui/react";
import { Link } from "react-router-dom";

function Main() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <MainDiv>
        <TextDiv>
          <div>
            <Heading as="h1" size="xl" isTruncated>
              Explore new places.
            </Heading>
          </div>

          <div>
            <Text color="gray" fontSize="xl">
              Find vacation rentals, cabins, beach houses, unique homes and
              experiences around the world - all made possible by hosts on
              HouseFlight.
            </Text>
          </div>

          <div>
            <Link to="/browse">
            <Button
              width="155px"
              color="white"
              bgColor="#EE575D"
              _hover={{ color: "#EE575D", bgColor: "#EDF2F7" }}
            >
              Explore now
            </Button>
            </Link>
          </div>
        </TextDiv>
        <img src={Home} alt="Logo"></img>
      </MainDiv>

      <MiddleDiv>
        <TitleDiv>
          <Heading fontSize="3xl" as="h1" size="2xl" isTruncated>
            Live anywhere{" "}
          </Heading>
        </TitleDiv>

        <FeatureDiv>
          <div>
            <Box
              width="300px"
              borderWidth="1px"
              borderRadius="lg"
              overflow="hidden"
            >
              <Image
                src="https://a0.muscache.com/im/pictures/2f13349d-879d-43c6-83e3-8e5679291d53.jpg?im_w=480"
                alt="Picture Home"
              />
            </Box>
            <Heading as="h3" size="md" isTruncated>
              Outdoor getaways
            </Heading>
          </div>
          <div>
            <Box
              width="300px"
              borderWidth="1px"
              borderRadius="lg"
              overflow="hidden"
            >
              <Image
                src="https://a0.muscache.com/im/pictures/36f53e61-db8d-403c-9122-5b761c0e4264.jpg?im_w=480"
                alt="Picture Home"
              />
            </Box>
            <Heading as="h3" size="md" isTruncated>
              Unique Stays
            </Heading>
          </div>
          <div>
            <Box
              width="300px"
              borderWidth="1px"
              borderRadius="lg"
              overflow="hidden"
            >
              <Image
                src="https://a0.muscache.com/im/pictures/7d82ca14-56e5-4465-8218-dcfa7d69b6ac.jpg?im_w=480"
                alt="Picture Home"
              />
            </Box>
            <Heading as="h3" size="md" isTruncated>
              Entire homes
            </Heading>
          </div>
          <div>
            <Box
              width="300px"
              borderWidth="1px"
              borderRadius="lg"
              overflow="hidden"
            >
              <Image
                src="https://a0.muscache.com/im/pictures/10a638e1-6aff-4313-8033-1275cec83987.jpg?im_w=480"
                alt="Picture Home"
              />
            </Box>
            <Heading as="h3" size="md" isTruncated>
              Pets allowed
            </Heading>
          </div>
        </FeatureDiv>
        <TitleDiv>
          <Heading fontSize="3xl" as="h1" size="2xl" isTruncated>
            Discover Experiences
          </Heading>
          <Heading fontSize="2xl" as="h3" size="sm" isTruncated>
            <Text fontSize="lg">
              Unique activities with local experts—in person or online.
            </Text>
          </Heading>
        </TitleDiv>
        <FeatureDiv>
          <div>
            <Box
              width="300px"
              borderWidth="1px"
              borderRadius="lg"
              overflow="hidden"
            >
              <Image
                src="https://a0.muscache.com/im/pictures/4bac6f05-928e-433c-8440-c992a72e9b44.jpg?im_w=480"
                alt="Picture Home"
              />
            </Box>
            <Text fontSize="xl">Outdoor collection</Text>
            <Text fontSize="md">Experiences that immerse you in nature.</Text>
          </div>
          <div>
            <Box
              width="300px"
              borderWidth="1px"
              borderRadius="lg"
              overflow="hidden"
            >
              <Image
                src="https://a0.muscache.com/im/pictures/a6b08861-feb8-4a01-a76d-b33d2867b441.jpg?im_w=480"
                alt="Picture Home"
              />
            </Box>
            <Text fontSize="xl">Outdoor collection</Text>
            <Text fontSize="md">Experiences that immerse you in nature.</Text>
          </div>
          <div>
            <Box
              width="300px"
              borderWidth="1px"
              borderRadius="lg"
              overflow="hidden"
            >
              <Image
                src="https://a0.muscache.com/im/pictures/ad109d56-2421-40cd-98e6-e114160dc85b.jpg?im_w=480"
                alt="Picture Home"
              />
            </Box>
            <Text fontSize="xl">Outdoor collection</Text>
            <Text fontSize="md">Experiences that immerse you in nature.</Text>
          </div>
        </FeatureDiv>
      </MiddleDiv>
    </Fragment>
  );
}

export default Main;

const MainDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 120px 30px;
  padding-top: 80px;

  img {
    flex-shrink: 0;
    width: 400px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    margin: 50px 40px;
  }
`;

const TextDiv = styled.div`
  display: flex;
  max-width: 400px;
  flex-direction: column;

  div {
    margin: 13px 0px;
  }
`;

const MiddleDiv = styled.div`
  margin: 120px 50px;

  /* div {
    margin-right: 20px;
} */
`;

const FeatureDiv = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin-bottom: 60px;

  @media (max-width: 1200px) {
    div {
      margin-top: 15px;
    }
  }
`;

const TitleDiv = styled.div`
  margin-bottom: 40px;

  h3 {
    margin-top: 10px;
  }
`;
